import { useEffect, useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { adminApi } from "@/lib/api";
import { RefreshCw } from "lucide-react";

export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  const load = () => adminApi.get("/admin/audit-logs", { params: { limit: 300 } }).then((r) => setLogs(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  return (
    <div className="max-w-6xl">
      <div className="flex items-center justify-between mb-2">
        <h1 className="font-heading font-bold text-2xl text-foreground" data-testid="admin-audit-title">Audit log</h1>
        <Button variant="outline" size="sm" onClick={load} data-testid="audit-refresh-button"><RefreshCw className="h-4 w-4 mr-1.5" /> Refresh</Button>
      </div>
      <p className="text-xs text-muted-foreground mb-6">Append-only. Every administrative and system action is recorded and cannot be edited or deleted.</p>
      <Card><CardContent className="p-0">
        <Table data-testid="audit-log-table">
          <TableHeader>
            <TableRow>
              <TableHead>At (UTC)</TableHead>
              <TableHead>Actor</TableHead>
              <TableHead>Action</TableHead>
              <TableHead>Entity</TableHead>
              <TableHead>Change</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {logs.map((l) => (
              <TableRow key={l.id}>
                <TableCell className="font-mono text-xs tabular-nums whitespace-nowrap">{l.at?.slice(0, 19).replace("T", " ")}</TableCell>
                <TableCell className="text-xs">{l.actor}</TableCell>
                <TableCell><Badge variant="outline" className="text-[10px] font-mono">{l.action}</Badge></TableCell>
                <TableCell className="text-xs">{l.entity}<p className="font-mono text-[10px] text-muted-foreground truncate max-w-[140px]">{l.entity_id}</p></TableCell>
                <TableCell className="text-[11px] text-muted-foreground max-w-sm">
                  {l.before_summary && <span>before: {JSON.stringify(l.before_summary)} </span>}
                  {l.after_summary && <span>after: {JSON.stringify(l.after_summary)}</span>}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent></Card>
    </div>
  );
}
